export default "__VITE_ASSET__BKHm9W8I__"